import { Component, OnInit } from '@angular/core';
import { MessageService } from 'primeng/api';
import { first } from 'rxjs';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { DepartmentDashboardService } from 'src/app/services/department-dashboard.service';
import { FarmersApplicationService } from 'src/app/services/farmers-application.service';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';

@Component({
  selector: 'app-epc-work-approval',
  templateUrl: './epc-work-approval.component.html',
  styleUrls: ['./epc-work-approval.component.scss']
})
export class EpcWorkApprovalComponent implements OnInit {

  public userId: any;

  // public hideGetDataButton: boolean = false;

  public contractorOutletList: any = [];
  public selectedOutletToGetData: any;
  public selectedBenefitedAreaToGetData: any;

  public agreementNoList: any = [];
  public agreementNoToGetData: any;

  public chunkList: any = [];
  public chunkIdToGetData: any;

  public epcDataForApproval: any = [];
  public epcDataForAppLandDetails: any = [];

  // public showActionDialog: boolean = false;

  public estimationDataForApproval: any = [];

  clonedProducts: { [s: string]: any } = {};

  public selectedJE: any;
  public selectedStatus: any;
  public remarks: any;
  public items: any = [];
  public jeList: any = [];

  public appStatusTypeList: any = [];
  public selectedAppStatus: any;

  public ipAddress: any = '000.000.000';
  public isRPCase: boolean = false;

  public grandTotalCost: any = 0;

  constructor(
    private loader: AppLoaderService,
    private fApplicationService: FarmersApplicationService,
    private messageService: MessageService,
    private vendorService: VendorDashboardService,
    private deptDashBoardService: DepartmentDashboardService,
    private ipService: IpAddressService,
    private activityRecordService: ActivityRecordService,
    private cryptoJsService: CryptoJsService
  ) { }

  ngOnInit(): void {
    this.getIP();
    this.getJEList();
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    this.userId = JSON.parse(payload)?.sub;

    this.getAppStatusTypeList();
    this.getStatusList();
  }

  getAppStatusTypeList() {
    setTimeout(() => {
      this.appStatusTypeList = [
        {
          status_Code: 1,
          status_Description: 'Pending'
        },
        // {
        //   status_Code: 2,
        //   status_Description: 'Current'
        // },
        {
          status_Code: 3,
          status_Description: 'Approved'
        },
        {
          status_Code: 4,
          status_Description: 'Return Process'
        },
        {
          status_Code: 5,
          status_Description: 'Rejected'
        }
      ]
    }, 200)
  }

  getJEList() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    // this.loader.start();
    this.deptDashBoardService
      .getJEUserIds(JSON.parse(payload)?.sub)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.jeList = data;

          // this.loader.close();
          // this.messageService.add({
          //   severity: 'success',
          //   summary: 'Success Message',
          //   detail: data.toString(),
          // });
        },
        error: (err) => {
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: `Next level user not found. ${err}`,
          });
        },
      });
  }

  getStatusList() {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    // this.loader.start();
    this.deptDashBoardService
      .getStatusMasterEPC(JSON.parse(payload)?.sub)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.items = data.$values;
          // this.loader.close();
          // this.messageService.add({
          //   severity: 'success',
          //   summary: 'Success Message',
          //   detail: data.toString(),
          // });
        },
        error: () => {
          // this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Status Master cant be Loaded',
          });
        },
      });
  }

  getContractorOutletList(contractorId, userId, status) {
    this.loader.start();
    this.fApplicationService
      .getOutletByContractor(contractorId, userId, status)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.contractorOutletList = res;
        },
        error: (err) => {
          this.loader.close();
          this.contractorOutletList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectAppStatus() {
    this.clearAllData();

    this.getContractorOutletList(0, this.userId, this.selectedAppStatus?.status_Description);

  }

  onSelectOutletToGetData() {
    this.agreementNoList = [];
    this.agreementNoToGetData = null;

    this.chunkList = [];
    this.chunkIdToGetData = null;
    
    this.epcDataForApproval = [];
    this.epcDataForAppLandDetails = [];
    this.estimationDataForApproval = [];

    this.selectedJE = null;
    this.selectedStatus = null;
    this.remarks = null;
    
    this.selectedBenefitedAreaToGetData = this.selectedOutletToGetData?.CCA_A;

    let conId = this.selectedOutletToGetData?.ContractorCode;
    let outletId = this.selectedOutletToGetData?.OutletId;
    let status = this.selectedAppStatus?.status_Description;
    this.getAgreementNumberList(conId, outletId, this.userId, status);
  }

  getAgreementNumberList(contractorId, outletId, userId, status) {
    this.loader.start();
    this.fApplicationService
      .getAgreementByContractor(contractorId, outletId, userId, status)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          this.agreementNoList = res;
        },
        error: (err) => {
          this.loader.close();
          this.agreementNoList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onSelectAgreementNo() {
    this.chunkList = [];
    this.chunkIdToGetData = null;
    
    this.epcDataForApproval = [];
    this.epcDataForAppLandDetails = [];
    this.estimationDataForApproval = [];

    this.selectedJE = null;
    this.selectedStatus = null;
    this.remarks = null;

    let outletId = this.selectedOutletToGetData?.OutletId;
    let contractorId = this.selectedOutletToGetData?.ContractorCode;
    let agreementNo = this.agreementNoToGetData?.AgreementNo;
    let status = this.selectedAppStatus?.status_Description;

    this.getChunkIdsList(contractorId, agreementNo, outletId, this.userId, status);
  }

  getChunkIdsList(contractorId, agreementNo, outletId, userId, status) {
    this.loader.start();
    this.fApplicationService
      .getChunkIds(contractorId, agreementNo, outletId, userId, status)
      .pipe(first())
      .subscribe({
        next: (res) => {
          this.loader.close();
          if(res.length > 0){
            this.chunkList = res.map(val => ({
              ...val,
              combineData: `${val?.ChunkId}. ${val?.FarmerName} (${val?.AppId})`
            }));
          }else{
            this.chunkList = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data not found',
            });
          }
        },
        error: (err) => {
          this.loader.close();
          this.chunkList = [];
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  onClickGetFarmerData() { 
    this.epcDataForApproval = [];
    this.epcDataForAppLandDetails = [];
    this.estimationDataForApproval = [];

    this.selectedJE = null;
    this.selectedStatus = null;
    this.remarks = null;

    let outletId = this.selectedOutletToGetData?.OutletId;
    let contractorId = this.selectedOutletToGetData?.ContractorCode;
    let agreementNo = this.agreementNoToGetData?.AgreementNo;
    let chunkId = this.chunkIdToGetData?.ChunkId;

    if (outletId && agreementNo) {
      this.getEPCFarmerDetails(agreementNo, outletId, chunkId);
      this.getEPCEstimationDetails(contractorId, outletId, agreementNo, chunkId);
    } else {
      this.messageService.add({
        severity: 'info',
        summary: 'Info Message',
        detail: 'Select Outlet and Fill Agreement Number.',
      });
    }
  }

  getEPCFarmerDetails(agreementNo, outletId, chunkId) {
    this.loader.start();
    this.vendorService
      .getEPCDetails(agreementNo, outletId, chunkId, this.userId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          let resp: any = data;
          if (resp?.otherDetails['$values'].length > 0) {
            // this.epcDataForApproval = resp;
            this.epcDataForApproval = resp?.otherDetails['$values'];
            this.epcDataForAppLandDetails = resp?.landDetails['$values'];
          } else {
            this.epcDataForApproval = [];
            this.epcDataForAppLandDetails = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Found',
            });
          }

          this.activityRecordService.activityRecord(this.userId, 'EPC Work For Approval Farmer (get grid details)', `${agreementNo}, ${outletId}, ${chunkId}`, new Date(), `${data}`);
        },
        error: (err) => {
          this.epcDataForApproval = [];
          this.epcDataForAppLandDetails = [];

          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
          this.activityRecordService.activityRecord(this.userId, 'EPC Work For Approval Farmer Error(get grid details)', `${agreementNo}, ${outletId}, ${chunkId}`, new Date(), err);
        },
      });
  }

  getEPCEstimationDetails(contractorId, outletId, agreementNo, chunkId) {
    this.loader.start();
    this.vendorService
      .getContractorEstimation(contractorId, outletId, agreementNo, chunkId)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          let resp: any = data;
          if (resp.length > 0) {
            this.grandTotalCost = resp.reduce((sum, d) => sum + Number(d.TotalAmount), 0);
    
            this.estimationDataForApproval = resp.map((val) => ({
              ...val,
              id: `${val?.ProgramID}_${val?.catId}_${val?.ComponentID}`,
              Price: val?.Price ? val?.Price : 0
            }));
          } else {
            this.estimationDataForApproval = [];
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: 'Data Not Found',
            });
          }

          this.activityRecordService.activityRecord(this.userId, 'EPC Work For Approval Estimation(get grid details)', `${contractorId}, ${agreementNo}, ${outletId}, ${chunkId}`, new Date(), `${data}`);
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.userId, 'EPC Work For Approval Estimation Error(get grid details)', `${contractorId}, ${agreementNo}, ${outletId}, ${chunkId}`, new Date(), err);
        },
      });
  }


  // clickOnAppAction(val){
  //   this.showActionDialog = true;
  // }

  // onCloseActionDialog(){
  //   this.showActionDialog = false;
  // }

  onRowEditInit(product: any) {
    this.clonedProducts[product.id as string] = { ...product };
  }

  onRowEditSave(product: any) {
    if (product.Price > 0) {
      delete this.clonedProducts[product.id as string];
      // this.messageService.add({ severity: 'success', summary: 'Success', detail: 'Price is updated' });
    } else {
      this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Invalid Price' });
    }
  }

  onRowEditCancel(product: any, index: number) {
    this.estimationDataForApproval[index] = this.clonedProducts[product.id as string];
    delete this.clonedProducts[product.id as string];
  }

  onClickSubmit() {

    // if (this.estimationDataForApproval.some(val => val?.Price <= 0)) {
    //   this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Please fill all the prices. price must be grater than 0.' });
    //   return;
    // }

    // if(this.selectedJE == null || this.selectedJE == undefined){
    //   this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Select next level user.' });
    //   return;
    // }

    // if (this.selectedStatus == undefined || this.selectedStatus == "") {
    //   this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Select Status' });
    //   return;
    // }

    if (this.selectedStatus?.flag == 'A' && (this.selectedJE == undefined || this.selectedJE == "")) {
      this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Select next level user.' });
      return;
    }

    if (this.remarks == undefined || this.remarks == "") {
      this.messageService.add({ severity: 'info', summary: 'Info', detail: 'Add Remark' });
      return;
    }
    
    let reqBody = [
      {
        outletId: this.selectedOutletToGetData?.OutletId,
        agreementNo: this.agreementNoToGetData?.AgreementNo,
        conId: this.selectedOutletToGetData?.ContractorCode,
        ChunkId: this.chunkIdToGetData?.ChunkId,
        status: this.selectedStatus?.flag,
        remarks: this.remarks,
        userId: this.userId,
        nextUserId: this.selectedJE?.UserID ? this.selectedJE?.UserID : "",
        network_Id: this.ipAddress,
        terminal_Id: this.ipAddress,
        data: this.estimationDataForApproval.map(val => ({
          srNo: val?.SrNo,
          // Price: val?.Price,
          Price: val?.PerUnitCost ? val?.PerUnitCost : 0,
          jeRemarks: val?.jeRemarks ? val?.jeRemarks : "",
          // jeQuantity: val?.jeQuantity ? val?.jeQuantity : 0
          jeQuantity: val?.Quantity,
        }))
      }
    ]

    this.submitEPCWork(reqBody);
  }

  submitEPCWork(reqBody) {
    let reqBodyFinal = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    this.loader.start();
    this.vendorService
      .insertComponentPriceEPC(reqBodyFinal)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data == 'Success') {
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: data,
            });
            this.clearAllData();
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }

          this.activityRecordService.activityRecord(this.userId, 'EPC Work For Approval Submit', `${reqBody}`, new Date(), `${data}`);
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(this.userId, 'EPC Work For Approval Submit Error', `${reqBody}`, new Date(), err);
        },
      });
  }

  clearAllData(){
    this.selectedOutletToGetData = null;
    this.selectedBenefitedAreaToGetData = null;

    this.agreementNoList = [];
    this.agreementNoToGetData = null;

    this.chunkList = [];
    this.chunkIdToGetData = null;
    
    this.epcDataForApproval = [];
    this.epcDataForAppLandDetails = [];
    this.estimationDataForApproval = [];

    this.selectedJE = null;
    this.selectedStatus = null;
    this.remarks = null;
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }

  onSelectStatus(){
    if(this.selectedStatus?.flag == 'RP' || this.selectedStatus?.flag == 'R'){
      this.isRPCase = true;
      this.selectedJE = null;
    }else{
      this.isRPCase = false;
    }
  }
}
